import RegisteredSiteDto from "../Common/dtos/RegisteredSiteDto";
import { QueryOptions } from "../Common/useQuery";
import useUserOrEmployeeQuery from "../Common/useUserOrEmployeeQuery";
import { useUserOrKaEmployee } from "../UserAccess/useUserOrKaEmployee";

const useGetSitesNonAdmin = (options?: QueryOptions<RegisteredSiteDto[]>) => {
  const { selectedBusiness } = useUserOrKaEmployee();

  return useUserOrEmployeeQuery<RegisteredSiteDto[]>(
    { path: `/api/businesses/${selectedBusiness?.id!}/sites/nonAdmin` },
    options);
}

export default useGetSitesNonAdmin;
